import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { Form, Input, Button, Select, Card, List, Typography } from "antd";
import { toast } from "react-toastify";

export default function AddDesignations() {
    const { backUrl, authData } = useContext(AuthContext);
    const { Option } = Select;
    const { Title } = Typography;

    const [organizations, setOrganizations] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [designations, setDesignations] = useState([]);

    const [selectedOrg, setSelectedOrg] = useState(null);
    const [selectedDept, setSelectedDept] = useState(null);

    const [newDesig, setNewDesig] = useState({
        name: "",
        department: "",
        grade: "",
        level: ""
    });

    const [loading, setLoading] = useState(false);

    // ✅ Fetch Organizations
    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results);
        } catch (err) {
            console.error("Error fetching organizations", err);
        }
    };

    // ✅ Fetch Departments based on Organization
    const fetchDepartments = async (orgId) => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/departments/?organisation=${orgId}`
            );
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Error fetching departments", err);
        }
    };

    // ✅ Fetch Designations based on Department
    const fetchDesignations = async (deptId) => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/designations/?department=${deptId}`
            );
            setDesignations(res.data.results);
        } catch (err) {
            console.error("Error fetching designations", err);
        }
    };

    // ✅ Add Designation
    const handleAddDesignation = async () => {
        if (!newDesig.name || !newDesig.department) {
            toast.error("Name and Department are required");
            return;
        }

        try {
            setLoading(true);

            await axios.post(
                `${backUrl}/api/emp/designations/`,
                newDesig,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success("Designation added successfully!");

            // Reset form
            setNewDesig({
                name: "",
                department: selectedDept,
                grade: "",
                level: ""
            });

            // Refresh list
            fetchDesignations(selectedDept);
        } catch (err) {
            console.error("Error adding designation", err);
            toast.error("Failed to add designation");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrganizations();
    }, []);

    return (
        <center>
            <div style={{ padding: "20px", width: '600px' }}>
                <Title level={4}>Add Designations</Title>

                {/* 🔹 Organization */}
                <Card style={{ marginBottom: "15px" }}>
                    <Select
                        placeholder="Select Organization"
                        style={{ width: "100%" }}
                        onChange={(value) => {
                            setSelectedOrg(value);
                            setSelectedDept(null);
                            setDesignations([]);
                            fetchDepartments(value);
                        }}
                    >
                        {organizations.map((org) => (
                            <Option key={org.id} value={org.id}>
                                {org.name}
                            </Option>
                        ))}
                    </Select>
                </Card>

                {/* 🔹 Department */}
                <Card style={{ marginBottom: "15px" }}>
                    <Select
                        placeholder="Select Department"
                        style={{ width: "100%" }}
                        value={selectedDept}
                        onChange={(value) => {
                            setSelectedDept(value);
                            setNewDesig({ ...newDesig, department: value });
                            fetchDesignations(value);
                        }}
                        disabled={!selectedOrg}
                    >
                        {departments.map((dept) => (
                            <Option key={dept.id} value={dept.id}>
                                {dept.name}
                            </Option>
                        ))}
                    </Select>
                </Card>

                {/* 🔹 Add Designation */}
                <Card title="Add Designation" style={{ marginBottom: "20px" }}>
                    <Form layout="vertical">
                        <Form.Item label="Designation Name">
                            <Input
                                placeholder="Enter designation"
                                value={newDesig.name}
                                onChange={(e) =>
                                    setNewDesig({ ...newDesig, name: e.target.value })
                                }
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            onClick={handleAddDesignation}
                            loading={loading}
                            disabled={!selectedDept}
                            style={{ backgroundColor: '#0e497b', color: 'white' }}
                            block
                        >
                            Add Designation
                        </Button>
                    </Form>
                </Card>

                {/* 🔹 List Designations */}
                {/* <Card title="Designations List">
                <List
                    bordered
                    dataSource={designations}
                    renderItem={(item) => (
                        <List.Item>
                            {item.name}
                        </List.Item>
                    )}
                    locale={{ emptyText: "No designations found" }}
                />
            </Card> */}
            </div>
        </center>
    );
}